/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable eqeqeq */
import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControlLabel, Grid, IconButton, InputAdornment, Link, MenuItem, Paper, TextField, Typography, makeStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import React, { Fragment, useEffect, useState, useRef } from 'react';
import classNames from 'classnames';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { CostUnit, displayCost } from '../../utilities/currencyFormatter';
import LogoSpinner from '../../common/logoSpinner.component';
import SelectionsCostBar from './selectionsCostBar.component';

import { getPackLoadMovePrice, getTempLivingPriceByRegion, setEstimations } from './estimator.actions';

import CloseIcon from '@material-ui/icons/Close';

import Spinner from 'common/logoSpinner.component';
import { setBackButtonPath, showToast, TOAST_MESSAGE_SEVERITY_ERROR } from 'modules/layout/layout.actions';

import { v4 as uuidv4 } from 'uuid';
import { detectIntent } from 'modules/policies/bot/dialogFlow.actions';
import { DETECT_INTENT_FAILURE } from 'modules/policies/bot/dialogFlow.types';
import { getBenefits } from './constants';
import { PDFDownloadLink } from '@react-pdf/renderer';
import DownloadableDoc from './downloadableDoc.component';
import Hint from 'common/hint.component';
import { getFinalMoveTravelCost, getGrossUpAmount, getTravelPartyCost } from './utils';

const useStyles = makeStyles((theme) => ({
  button: {
    width: 80,
    marginRight: '5px'
  },
  longButton: {
    width: 125
  },
  moveGuideHeader:{
    height: '75px',
    borderBottom: 2,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.palette.divider,
    color: '#7F7F7F',
    borderRadius: `${theme.spacing(1)} ${theme.spacing(1)} 0 0`,
  },
  progressBar: {
    width: '100%',
  },
  optionRow: {
    borderTopStyle: 'solid',
    borderTopWidth: '1px',
    borderTopColor: theme.palette.divider,
    minHeight: theme.spacing(3),
  },
  benefitImage: {
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    height: '60px',
  },
  benefitImageSkipped: {
    filter: 'grayscale(100%)',
  },
  optionQuantityText:{
    fontStyle: 'italic',
    fontSize: '0.6rem',
  },
  benefitListContainer: {
    overflow: 'auto',
  },
  benefitListWrapper: {
    overflow: 'auto',
  },
  loadingOverlay :{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 3,
    backgroundColor: 'rgba(0,0,0,0.3)', // controls black overlay opacity
    display: 'flex',
  },
  benefitSelected: {
    boxShadow: '0px 0px 12px 1px rgba(90,154,156,0.5)',
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  textField: {
    maxWidth: '200px',
  },
}));



const BenefitSelections = (props) => {
  const { benefits, estimateId, isUpdatingSelections, savingEstimate, isHeaderDirty, policyId, updatedPolicyBenefits, updatedGrossUp, isPremium, freeDownloadInfo, setParentBenefitListDirty, lastDayHasPassed } = props;
  const [expandedBenefitId, setExpandedBenefitId] = useState(null);
  const [savedBenefits, setSavedBenefits] = useState(() => {
    // Deduplicate custom benefit options on initial load
    const initialBenefits = props.estimateInfo && props.estimateInfo.savedBenefits ? props.estimateInfo.savedBenefits : [];
    return initialBenefits.map(benefit => {
      if (benefit.benefitNumber === 9 && benefit.options) {
        const deduplicatedOptions = benefit.options.filter((opt, index, self) => 
          index === self.findIndex(o => o.optionNumber === opt.optionNumber)
        );
        return { ...benefit, options: deduplicatedOptions };
      }
      return benefit;
    });
  });
  
  // Track if we should skip recalculation to preserve saved customCost values
  // Compute hasSavedCustomCosts immediately during render, not in useEffect
  const hasSavedCustomCosts = useRef(
    props.estimateInfo?.savedBenefits?.some(benefit => 
      benefit.options?.some(opt => opt.customCost !== undefined && opt.customCost !== null)
    ) || false
  );
  // Track if user has made changes that require recalculation
  const hasUserMadeChanges = useRef(false);
  // Track previous accompanyingAdults to detect actual changes (not initial mount)
  const prevAccompanyingAdults = useRef(freeDownloadInfo?.estimateInfo?.accompanyingAdults);
  // Track the previous values of dependencies to detect actual changes vs initial load
  const prevDependencyValues = useRef(null);
  // Track if we've initialized from props (for delayed prop arrival)
  const hasInitializedFromProps = useRef(
    props.estimateInfo?.savedBenefits?.length > 0
  );

  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [selectedBenefit, setSelectedBenefit] = useState(null);
  const [selectedBenefitOptions, setSelectedBenefitOptions] = useState(null);
  const [topLevelInputOneId, setTopLevelInputOneId] = useState(props.estimateInfo && props.estimateInfo.topLevelInputOneId ? props.estimateInfo.topLevelInputOneId : null);
  const [topLevelInputTwoId, setTopLevelInputTwoId] = useState(props.estimateInfo && props.estimateInfo.topLevelInputTwoId ? props.estimateInfo.topLevelInputTwoId : null);
  const [topLevelInputThreeId, setTopLevelInputThreeId] = useState(props.estimateInfo && props.estimateInfo.topLevelInputThreeId ? props.estimateInfo.topLevelInputThreeId : null);
  const [topLevelInputFourId, setTopLevelInputFourId] = useState(props.estimateInfo && props.estimateInfo.topLevelInputFourId ? props.estimateInfo.topLevelInputFourId : null);
  const [topLevelInputFive, setTopLevelInputFive] = useState((props.estimateInfo && props.estimateInfo.topLevelInputFive) ? props.estimateInfo.topLevelInputFive : false);
  const [topLevelInputSix, setTopLevelInputSix] = useState((props.estimateInfo && props.estimateInfo.topLevelInputSix) ? props.estimateInfo.topLevelInputSix : false);
  const [topLevelInputSeven, setTopLevelInputSeven] = useState((props.estimateInfo && props.estimateInfo.topLevelInputSeven) ? props.estimateInfo.topLevelInputSeven : null);
  const [topLevelInputEight, setTopLevelInputEight] = useState((props.estimateInfo && props.estimateInfo.topLevelInputEight) ? props.estimateInfo.topLevelInputEight : false);
  const [topLevelInputNine, setTopLevelInputNine] = useState((props.estimateInfo && props.estimateInfo.topLevelInputNine) ? props.estimateInfo.topLevelInputNine : null);

  const [tempLivingDaysCost, setTempLivingDaysCost] = useState(0);
  const [packLoadCost, setPackLoadCost] = useState(0);
  const [thirtyDayStorageCost, setThirtyDayStorageCost] = useState(0);
  const [sixtyDayStorageCost, setSixtyDayStorageCost] = useState(0);
  const [isUpdatingBenefitPrice, setIsUpdatingBenefitPrice] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [applyTaxGrossUp, setApplyTaxGrossUp] = useState(props.estimateInfo && props.estimateInfo.applyTaxGrossUp ? true : false);
  const [grossUpPercentage, setGrossUpPercentage] = useState(props.estimateInfo && props.estimateInfo.grossUpPercentage ? props.estimateInfo.grossUpPercentage : 60);
  const [showTaxGrossUpInput, setShowTaxGrossUpInput] = useState(false);

  const [customTotal, setCustomTotal] = useState((props.estimateInfo && props.estimateInfo.savedBenefits && props.estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 8)) ? props.estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 8).cost : 3000);
  const [customTotalIsTaxable, setCustomTotalIsTaxable] = useState((props.estimateInfo && props.estimateInfo.savedBenefits && props.estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 8)) ? props.estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 8).isTaxable : false);

  const [customLineItemOneCost, setCustomLineItemOneCost] = useState((props.estimateInfo && props.estimateInfo.savedBenefits && props.estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 9))?.options ? props.estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 9).options.find((opt) => opt.optionNumber === 28)?.customCost : 0);
  const [customLineItemOneText, setCustomLineItemOneText] = useState((props.estimateInfo && props.estimateInfo.savedBenefits && props.estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 9))?.options ? props.estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 9).options.find((opt) => opt.optionNumber === 28)?.customDescription : '');
  const [customLineItemTwoCost, setCustomLineItemTwoCost] = useState((props.estimateInfo && props.estimateInfo.savedBenefits && props.estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 9))?.options ? props.estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 9).options.find((opt) => opt.optionNumber === 29)?.customCost : 0);
  const [customLineItemTwoText, setCustomLineItemTwoText] = useState((props.estimateInfo && props.estimateInfo.savedBenefits && props.estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 9))?.options ? props.estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 9).options.find((opt) => opt.optionNumber === 29)?.customDescription : '');
  const [customLineItemThreeCost, setCustomLineItemThreeCost] = useState((props.estimateInfo && props.estimateInfo.savedBenefits && props.estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 9))?.options ? props.estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 9).options.find((opt) => opt.optionNumber === 30)?.customCost : 0);
  const [customLineItemThreeText, setCustomLineItemThreeText] = useState((props.estimateInfo && props.estimateInfo.savedBenefits && props.estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 9))?.options ? props.estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 9).options.find((opt) => opt.optionNumber === 30)?.customDescription : '');

  const [isBenefitListDirty, setIsBenefitListDirty] = useState(false);

  const [sessionId] = useState(uuidv4());
  const [showHintModal, setShowHintModal] = useState(false);
  const [hintText, setHintText] = useState(null);
  const [hintHeader, setHintHeader] = useState(null);

  const [showGeneralHintModal, setShowGeneralHintModal] = useState(false);
  const [selectedHintOption, setSelectedHintOption] = useState(null);
  const [selectedHintText, setSelectedHintText] = useState(null);

  const [customLineChecked, setCustomLineChecked] = useState(false);
  const [customLineDescription, setCustomLineDescription] = useState('Additional Benefit');
  const [customLineCost, setCustomLineCost] = useState(0);

  const classes = useStyles();

  // Recalculate costs for currently selected benefit options in the modal
  const recalculateModalOptionCosts = (options, benefit) => {
    if (!benefit || !options) return options;

    const currentBenefit = benefits.find((current) => current.benefitNumber === benefit.benefitNumber) || benefit;
    return options.map(option => {
      const benefitOption = currentBenefit.options.find(bo => bo.optionNumber === option.optionNumber);
      if (!benefitOption) return option;

      // Don't recalculate for custom benefits
      if (benefit.customBenefit && option.customCost !== undefined) {
        return option;
      }

      // Temporarily remove customCost to force recalculation
      const optionWithoutCustomCost = { ...option };
      delete optionWithoutCustomCost.customCost;

      const calculatedCost = getOptionCost(benefitOption, optionWithoutCustomCost);

      return {
        ...option,
        customCost: calculatedCost
      };
    });
  };

  const setBenOptionSelection = (checked, opt) => {
    let tempSelectedBenefitOptions = [...selectedBenefitOptions];
    if (checked) {
      tempSelectedBenefitOptions.push({ optionNumber: opt.optionNumber, selectionId: opt.selections ? opt.selections[0].selectionId : undefined});
    } else {
      tempSelectedBenefitOptions = tempSelectedBenefitOptions.filter((tsb) => tsb.optionNumber !== opt.optionNumber);
      
      // For custom benefits, also clear the corresponding state variables when unchecking
      if (selectedBenefit && selectedBenefit.customBenefit) {
        if (opt.optionNumber === 28) {
          setCustomLineItemOneCost(0);
          setCustomLineItemOneText('');
        } else if (opt.optionNumber === 29) {
          setCustomLineItemTwoCost(0);
          setCustomLineItemTwoText('');
        } else if (opt.optionNumber === 30) {
          setCustomLineItemThreeCost(0);
          setCustomLineItemThreeText('');
        }
      }
    }
    
    // Recalculate costs immediately
    if (selectedBenefit && !selectedBenefit.customBenefit && !selectedBenefit.customTotal) {
      tempSelectedBenefitOptions = recalculateModalOptionCosts(tempSelectedBenefitOptions, selectedBenefit);
    }
    
    setSelectedBenefitOptions(tempSelectedBenefitOptions);
  }

  const setBenOptionDropdown = (opt, val) => {
    let tempSelectedBenefitOptions = [...selectedBenefitOptions];
    let optIndex = tempSelectedBenefitOptions.findIndex((tsbo) => tsbo.optionNumber === opt.optionNumber);
    if (optIndex != null) {
      tempSelectedBenefitOptions[optIndex].selectionId = Number(val);
    } else {
      tempSelectedBenefitOptions.push({ optionNumber: opt.optionNumber, selectionId: Number(val)});
    }
    
    // Recalculate costs immediately
    if (selectedBenefit && !selectedBenefit.customBenefit && !selectedBenefit.customTotal) {
      tempSelectedBenefitOptions = recalculateModalOptionCosts(tempSelectedBenefitOptions, selectedBenefit);
    }
    
    setSelectedBenefitOptions(tempSelectedBenefitOptions);
  }

  const getOptionCost = (opt, selectedOption) => {
    if (!opt) return 0;

    if (opt.optionNumber === 23) {
      return getFinalMoveTravelCost(opt, selectedOption, props.distance, freeDownloadInfo?.estimateInfo?.accompanyingAdults);
    }

    const relevantBenefit = benefits.find((b) => b.benefitNumber === opt.benefitNumber);

    const savedReloAllowanceBenefit = savedBenefits.find((sb) => sb.benefitNumber === 8);

    if (savedReloAllowanceBenefit && opt.optionNumber === 27) {
      return savedReloAllowanceBenefit.cost ? Number(savedReloAllowanceBenefit.cost) : 0;
    } else if (selectedOption && opt.customOption) {
      return selectedOption.customCost ? Number(selectedOption.customCost) : 0;
    } else if (selectedOption && selectedOption.customCost !== undefined && selectedOption.customCost !== null && selectedOption.customCost !== 0 && Number.isFinite(Number(selectedOption.customCost))) {
      // Return saved customCost if it exists and is not 0 (for non-custom benefits)
      return Number(selectedOption.customCost);
    } else if (selectedOption && selectedOption.selectionId && opt.optionNumber !== 11 && opt.optionNumber !== 13) {
      const selectionCost = (opt.selections && opt.selections.find((selection) => selection.selectionId === selectedOption.selectionId)) ? opt.selections.find((selection) => selection.selectionId === selectedOption.selectionId).cost : 0;
console.log(freeDownloadInfo);
      // Homefinding - Lodging and meal per diem calculations
      if ((opt.optionNumber === 15 || opt.optionNumber === 31) && topLevelInputFourId && topLevelInputFourId !== 1) {
        if (topLevelInputFourId === 2) {
          return selectionCost * 2;
        } else if (topLevelInputFourId === 3 && freeDownloadInfo && freeDownloadInfo.estimateInfo) {
          return getTravelPartyCost(selectionCost, freeDownloadInfo.estimateInfo.accompanyingAdults);
        } else {
          return selectionCost;
        }
      // Final Trip - Lodging and meal per diem calculations
      } else if ((opt.optionNumber === 24 || opt.optionNumber === 32) && freeDownloadInfo) {
        return getTravelPartyCost(selectionCost, freeDownloadInfo.estimateInfo?.accompanyingAdults);
      // HHG - Storage in transit calculations
      } else if (opt.optionNumber === 6) {
        if (selectionCost === 30) {
          return thirtyDayStorageCost;
        } else {
          return sixtyDayStorageCost;
        }
      } else {
        return selectionCost;
      }
    } else {
      if (opt.optionNumber === 17) {
        const perDiemSelectionId = (relevantBenefit && savedBenefits && savedBenefits.find((sb) => relevantBenefit.benefitNumber === sb.benefitNumber)) ? savedBenefits.find((sb) => relevantBenefit.benefitNumber === sb.benefitNumber).options.find((opt) => opt.optionNumber === 15)?.selectionId : null;
        const numDaysBetweenFlights = perDiemSelectionId ? (perDiemSelectionId === 8 ? 1 : (perDiemSelectionId === 9 ? 2 : (perDiemSelectionId === 11 ? 4 : 3))) : 3;
        return 98.89 * numDaysBetweenFlights;
      } else if (opt.optionNumber === 1) {
        return packLoadCost;
      } else if (opt.optionNumber === 11) {
        let tempLivingDaysSelectionId = 1;

        // Check selectedOption first (when editing in modal), then fall back to savedBenefits
        if (selectedOption && selectedOption.selectionId) {
          tempLivingDaysSelectionId = selectedOption.selectionId;
        } else if (savedBenefits && savedBenefits.length > 0 && savedBenefits.find((sb) => sb.benefitNumber === 2)) {
          tempLivingDaysSelectionId = savedBenefits.find((sb) => sb.benefitNumber === 2).options.find((opt) => opt.optionNumber === 11) ? savedBenefits.find((sb) => sb.benefitNumber === 2).options.find((opt) => opt.optionNumber === 11).selectionId : 0;
        }

        return tempLivingDaysCost * tempLivingDaysSelectionId * 30;
      // Homefinding - Airfare cost calculations
      } else if (props.distance > 350 && opt.optionNumber === 14 && topLevelInputFourId && topLevelInputFourId !== 1) {
        if (topLevelInputFourId === 2) {
          return opt.cost * 2;
        } else if (topLevelInputFourId === 3 && freeDownloadInfo && freeDownloadInfo.estimateInfo) {
          return getTravelPartyCost(opt.cost, freeDownloadInfo.estimateInfo.accompanyingAdults);
        } else {
          return opt.cost;
        }
      // Temporary Living - Rental car days calculations
      } else if (opt.optionNumber === 13 && selectedOption && selectedOption.selectionId) {
        return opt.cost * selectedOption.selectionId;
      // Home Purchasing - Direct bill / reimbursement amount
      } else if (opt.optionNumber === 19) {
        if (topLevelInputEight) {
          return topLevelInputNine ? Number(topLevelInputNine * 0.02) : 0;
        } else {
          return opt.cost;
        }
      // Home Sale - Reimbursement amount
      } else if (opt.optionNumber === 21) {
        if (topLevelInputSix) {
          return topLevelInputSeven ? Number(topLevelInputSeven * 0.08) : 0;
        } else {
          return opt.cost;
        }
      } else {
        return opt.cost;
      }
    }
  }

  // Helper function to calculate and attach customCost to each option
  const calculateAndAttachCosts = (options, benefit) => {
    return options.map(option => {
      const benefitOption = benefit.options.find(bo => bo.optionNumber === option.optionNumber);
      if (!benefitOption) return option;
      
      // Don't override customCost for custom benefits (benefitNumber 9)
      if (benefit.customBenefit && option.customCost !== undefined) {
        return option;
      }
      
      // Calculate the cost for this option
      const calculatedCost = getOptionCost(benefitOption, option);
      
      return {
        ...option,
        customCost: calculatedCost
      };
    });
  };

  const enableBenefit = () => {
    setIsLoading(true);
    hasUserMadeChanges.current = true;

    setTimeout(() => {}, 2000);

    let tempSavedBenefits = [...savedBenefits];
    if (selectedBenefit.customTotal) {
      if (policyId) {
        tempSavedBenefits.push({ benefitNumber: selectedBenefit.benefitNumber, policyId: policyId, options: selectedBenefitOptions, cost: Number(customTotal), isTaxable: customTotalIsTaxable});
      } else {
        tempSavedBenefits.push({ benefitNumber: selectedBenefit.benefitNumber, estimateId: estimateId, options: selectedBenefitOptions, cost: Number(customTotal), isTaxable: customTotalIsTaxable});
      }
    } else if (selectedBenefit.customBenefit) {
      // Build options array from state variables to include all line items with data
      // IMPORTANT: Also check selectedBenefitOptions to ensure the item is actually checked
      const customBenefitOptions = [];
      
      const isOption1Checked = selectedBenefitOptions.some(opt => opt.optionNumber === 28);
      const isOption2Checked = selectedBenefitOptions.some(opt => opt.optionNumber === 29);
      const isOption3Checked = selectedBenefitOptions.some(opt => opt.optionNumber === 30);
      
      if (isOption1Checked && ((customLineItemOneCost && customLineItemOneCost > 0) || (customLineItemOneText && customLineItemOneText.length > 0))) {
        customBenefitOptions.push({ optionNumber: 28, benefitNumber: 9, customCost: Number(customLineItemOneCost) || 0, customDescription: customLineItemOneText });
      }
      if (isOption2Checked && ((customLineItemTwoCost && customLineItemTwoCost > 0) || (customLineItemTwoText && customLineItemTwoText.length > 0))) {
        customBenefitOptions.push({ optionNumber: 29, benefitNumber: 9, customCost: Number(customLineItemTwoCost) || 0, customDescription: customLineItemTwoText });
      }
      if (isOption3Checked && ((customLineItemThreeCost && customLineItemThreeCost > 0) || (customLineItemThreeText && customLineItemThreeText.length > 0))) {
        customBenefitOptions.push({ optionNumber: 30, benefitNumber: 9, customCost: Number(customLineItemThreeCost) || 0, customDescription: customLineItemThreeText });
      }

      // Deduplicate by optionNumber (defensive programming)
      const deduplicatedOptions = customBenefitOptions.filter((opt, index, self) => 
        index === self.findIndex(o => o.optionNumber === opt.optionNumber)
      );

      // Only add the benefit if there are actually options selected
      // Don't save empty custom benefits (backend can't handle empty options arrays properly)
      if (deduplicatedOptions.length > 0) {
        if (policyId) {
          tempSavedBenefits.push({ benefitNumber: selectedBenefit.benefitNumber, policyId: policyId, options: deduplicatedOptions, isTaxable: customTotalIsTaxable});
        } else {
          tempSavedBenefits.push({ benefitNumber: selectedBenefit.benefitNumber, estimateId: estimateId, options: deduplicatedOptions, isTaxable: customTotalIsTaxable});
        }
      }
    } else {
      // Calculate and attach costs to each option before saving
      const optionsWithCosts = calculateAndAttachCosts(selectedBenefitOptions, selectedBenefit);
      
      if (policyId) {
        tempSavedBenefits.push({ benefitNumber: selectedBenefit.benefitNumber, policyId: policyId, customLineCost: customLineCost, customLineDescription: customLineDescription, customLineChecked: customLineChecked, options: optionsWithCosts});
      } else {
        tempSavedBenefits.push({ benefitNumber: selectedBenefit.benefitNumber, estimateId: estimateId, customLineCost: customLineCost, customLineDescription: customLineDescription, customLineChecked: customLineChecked, options: optionsWithCosts});
      }
    }
    setSavedBenefits(tempSavedBenefits);

    setIsLoading(false);
    setShowUpdateModal(false);
  }

  const updateBenefit = () => {
    setIsLoading(true);
    hasUserMadeChanges.current = true;

    let tempSavedBenefits = [...savedBenefits];
    let tempSavedBenefitIndex = tempSavedBenefits.findIndex((tsb) => tsb.benefitNumber === selectedBenefit.benefitNumber);
    if (selectedBenefit.customTotal) {
      if (policyId) {
        tempSavedBenefits[tempSavedBenefitIndex] = {benefitNumber: selectedBenefit.benefitNumber, id: tempSavedBenefits[tempSavedBenefitIndex].id, policyId: policyId, options: selectedBenefitOptions, cost: Number(customTotal), isTaxable: customTotalIsTaxable};
      } else {
        tempSavedBenefits[tempSavedBenefitIndex] = {benefitNumber: selectedBenefit.benefitNumber, id: tempSavedBenefits[tempSavedBenefitIndex].id, estimateId: estimateId, options: selectedBenefitOptions, cost: Number(customTotal), isTaxable: customTotalIsTaxable};
      }
    } else if (selectedBenefit.customBenefit) {
      // Build options array from state variables to include all line items with data
      // IMPORTANT: Also check selectedBenefitOptions to ensure the item is actually checked
      const customBenefitOptions = [];
      
      const isOption1Checked = selectedBenefitOptions.some(opt => opt.optionNumber === 28);
      const isOption2Checked = selectedBenefitOptions.some(opt => opt.optionNumber === 29);
      const isOption3Checked = selectedBenefitOptions.some(opt => opt.optionNumber === 30);
      
      if (isOption1Checked && ((customLineItemOneCost && customLineItemOneCost > 0) || (customLineItemOneText && customLineItemOneText.length > 0))) {
        customBenefitOptions.push({ optionNumber: 28, benefitNumber: 9, customCost: Number(customLineItemOneCost) || 0, customDescription: customLineItemOneText });
      }
      if (isOption2Checked && ((customLineItemTwoCost && customLineItemTwoCost > 0) || (customLineItemTwoText && customLineItemTwoText.length > 0))) {
        customBenefitOptions.push({ optionNumber: 29, benefitNumber: 9, customCost: Number(customLineItemTwoCost) || 0, customDescription: customLineItemTwoText });
      }
      if (isOption3Checked && ((customLineItemThreeCost && customLineItemThreeCost > 0) || (customLineItemThreeText && customLineItemThreeText.length > 0))) {
        customBenefitOptions.push({ optionNumber: 30, benefitNumber: 9, customCost: Number(customLineItemThreeCost) || 0, customDescription: customLineItemThreeText });
      }

      // Deduplicate by optionNumber (defensive programming)
      const deduplicatedOptions = customBenefitOptions.filter((opt, index, self) => 
        index === self.findIndex(o => o.optionNumber === opt.optionNumber)
      );

      // If no options are selected, disable the benefit entirely instead of saving empty options
      // This is a workaround for the backend not properly handling empty options arrays
      if (deduplicatedOptions.length === 0) {
        tempSavedBenefits = tempSavedBenefits.filter((tsb) => selectedBenefit.benefitNumber !== tsb.benefitNumber);
      } else {
        if (policyId) {
          tempSavedBenefits[tempSavedBenefitIndex] = { benefitNumber: selectedBenefit.benefitNumber, id: tempSavedBenefits[tempSavedBenefitIndex].id, policyId: policyId, options: deduplicatedOptions, isTaxable: customTotalIsTaxable};
        } else {
          tempSavedBenefits[tempSavedBenefitIndex] = { benefitNumber: selectedBenefit.benefitNumber, id: tempSavedBenefits[tempSavedBenefitIndex].id, estimateId: estimateId, options: deduplicatedOptions, isTaxable: customTotalIsTaxable};
        }
      }
    } else {
      // Calculate and attach costs to each option before saving
      const optionsWithCosts = calculateAndAttachCosts(selectedBenefitOptions, selectedBenefit);
      
      if (policyId) {
        tempSavedBenefits[tempSavedBenefitIndex] = {benefitNumber: selectedBenefit.benefitNumber, id: tempSavedBenefits[tempSavedBenefitIndex].id, policyId: policyId, customLineCost: customLineCost, customLineDescription: customLineDescription, customLineChecked: customLineChecked, options: optionsWithCosts};
      } else {
        tempSavedBenefits[tempSavedBenefitIndex] = {benefitNumber: selectedBenefit.benefitNumber, id: tempSavedBenefits[tempSavedBenefitIndex].id, estimateId: estimateId, customLineCost: customLineCost, customLineDescription: customLineDescription, customLineChecked: customLineChecked, options: optionsWithCosts};
      }
    }

    setSavedBenefits(tempSavedBenefits);

    setIsLoading(false);
    setShowUpdateModal(false);
  }

  const disableBenefit = () => {
    setIsLoading(true);
    hasUserMadeChanges.current = true;

    let tempSavedBenefits = [...savedBenefits];
    tempSavedBenefits = tempSavedBenefits.filter((tsb) => selectedBenefit.benefitNumber !== tsb.benefitNumber);
    setSavedBenefits(tempSavedBenefits);

    setIsLoading(false);
    setShowUpdateModal(false);
  }

  const handleAccordionChange = (benefitId) => (event, isExpanded) => {
    setExpandedBenefitId(isExpanded ? benefitId : false);
  };

  const renderOption = (option, benefit, benIsSelected, optIsSelected) => {
    let optionText = '';
    let savedOption = savedBenefits.find((sb) => sb.benefitNumber === benefit.benefitNumber) ? savedBenefits.find((sb) => sb.benefitNumber === benefit.benefitNumber).options.find((sbo) => sbo.optionNumber === option.optionNumber) : null;
    
    if (option.selections && savedOption && option.selections.find((os) => os.selectionId === savedOption.selectionId)) {
      optionText = savedOption ? `${option.description} (${option.selections.find((os) => os.selectionId === savedOption.selectionId).text})` : option.description;
    } else if (savedOption && savedOption.customDescription) {
      optionText = savedOption.customDescription;
    } else if (savedOption && savedOption.selectionId && option.freeNumberField) {
      optionText = `${option.description} (${savedOption.selectionId} ${option.freeNumberMultiplier})`;
    } else if (savedOption && option.optionNumber === 21 && topLevelInputFive) {
      optionText = 'Direct reimbursement (Subject to gross up)';
    } else {
      optionText = option.description;
    }

    // Hide empty custom benefit options (ones that weren't selected/filled in)
    if (benefit.customBenefit && ((savedOption && (!savedOption.customDescription || savedOption.customDescription.length === 0) && (!savedOption.customCost || savedOption.customCost === 0)) || !savedOption)) {
      return null;
    }

    return (
      <Grid item container direction="row" className={classes.optionRow}>
        <Grid item xs={8} container direction="column">
          <Grid item>
            <Box sx={{display: 'flex', flexDirection: 'row'}}>
              <Typography variant="body2">
                {optionText}
              </Typography>
              {option.helpIntentId && (
                <Box sx={{marginLeft: '5px'}}>
                  <Box sx={{cursor: 'pointer'}} onClick={() => helpModalOpened(option)}>
                    <FontAwesomeIcon color={'primary'} icon={['fas', 'question-circle']} />
                  </Box>
                </Box>
              )}
            </Box>
          </Grid>
        </Grid>
        <Grid item container xs={2} justify="flex-end" alignContent="center">
          {!benefit.customBenefit && (
            <>
              {!benefit.customTotal && (
                <Typography variant="caption">{displayCost(getOptionCost(option, savedOption), CostUnit.CURRENCY)}</Typography>
              )}
              {benefit.customTotal && (
                <Typography variant="caption">{displayCost(savedBenefits.find((sb) => sb.benefitNumber === benefit.benefitNumber) ? Number(savedBenefits.find((sb) => sb.benefitNumber === benefit.benefitNumber).cost) : 3000, CostUnit.CURRENCY)}</Typography>
              )}
            </>
          )}
          {benefit.customBenefit && (
            <Typography variant="caption">{displayCost(getOptionCost(option, savedOption), CostUnit.CURRENCY)}</Typography>
          )}
        </Grid>
        <Grid item container xs={2} justify="flex-start" alignContent="center">
          {benIsSelected && optIsSelected && 
            <Box pl={2}>
              <Typography variant="caption" color="secondary"><FontAwesomeIcon icon="check-circle" /> Confirmed</Typography>
            </Box>
          }
          {benIsSelected && !optIsSelected && 
            <Box pl={2}>
              <Typography variant="caption" color="error"><FontAwesomeIcon icon="times-circle" /> Declined</Typography>
            </Box>
          }
        </Grid>
      </Grid>
    )
  };

  const renderBenefitRowAction = (benefit, savedBenefit) => {
    if (savedBenefit) {
        return (
                <Button size="small" variant="outlined" disabled={false} color="primary" onClick={(e) => { 
                  setSelectedBenefit(benefit); 
                  
                  // For custom benefits, only include options that have actual data
                  let optionsToShow = savedBenefit.options;
                  if (benefit.customBenefit) {
                    optionsToShow = savedBenefit.options.filter(opt => 
                      (opt.customDescription && opt.customDescription.length > 0) || 
                      (opt.customCost && opt.customCost > 0)
                    );
                  }
                  
                  setSelectedBenefitOptions(optionsToShow); 
                  setShowUpdateModal(true); 
                  setCustomLineChecked(savedBenefit.customLineChecked); 
                  setCustomLineDescription(savedBenefit.customLineDescription); 
                  setCustomLineCost(savedBenefit.customLineCost); 
                  
                  // Populate custom benefit option fields for Additional Benefits
                  if (benefit.customBenefit && savedBenefit.options) {
                    // Deduplicate options in case backend data has duplicates
                    const deduplicatedOptions = savedBenefit.options.filter((opt, index, self) => 
                      index === self.findIndex(o => o.optionNumber === opt.optionNumber)
                    );
                    
                    const option1 = deduplicatedOptions.find((opt) => opt.optionNumber === 28);
                    const option2 = deduplicatedOptions.find((opt) => opt.optionNumber === 29);
                    const option3 = deduplicatedOptions.find((opt) => opt.optionNumber === 30);
                    
                    setCustomLineItemOneCost(option1?.customCost || 0);
                    setCustomLineItemOneText(option1?.customDescription || '');
                    setCustomLineItemTwoCost(option2?.customCost || 0);
                    setCustomLineItemTwoText(option2?.customDescription || '');
                    setCustomLineItemThreeCost(option3?.customCost || 0);
                    setCustomLineItemThreeText(option3?.customDescription || '');
                  }
                }}>
                    Update
                </Button>
        )
    } else {
      let tempBenefitOptions = [];
      benefit.options.map((bo) => tempBenefitOptions.push({ optionNumber: bo.optionNumber, selectionId: bo.defaultSelectionId ? bo.defaultSelectionId: undefined}));
        return (
                <Button size="small" variant="contained" disabled={false} color="primary" onClick={(e) => { 
                  setSelectedBenefit(benefit); 
                  setSelectedBenefitOptions(tempBenefitOptions); 
                  setShowUpdateModal(true); 
                  setCustomLineChecked(false); 
                  setCustomLineDescription(''); 
                  setCustomLineCost(0);
                  // Reset custom benefit state variables when enabling
                  if (benefit.customBenefit) {
                    setCustomLineItemOneCost(0);
                    setCustomLineItemOneText('');
                    setCustomLineItemTwoCost(0);
                    setCustomLineItemTwoText('');
                    setCustomLineItemThreeCost(0);
                    setCustomLineItemThreeText('');
                  }
                }}>
                    Enable
                </Button>
        )
    }
  };

  const resetBenefits = () => {
    setSavedBenefits([]);
  };

  const helpModalOpened = async (option) => {
    setHintHeader(option.description);
    setShowHintModal(true);

    const action = await props.detectIntent(sessionId, option.helpIntentId, { event: { languageCode: 'en', name: option.helpIntentId }});
    if (action.type === DETECT_INTENT_FAILURE) {
      props.showToast(`Failed to generate benefit option hint.`, { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return;
    } else {
      setHintText(action.response.queryResult.fulfillmentText);
    }
  }

  const generalBenefitHelpSelected = async (benefit) => {
    setShowGeneralHintModal(true);
    setSelectedHintText('');

    // const action = await props.detectIntent(sessionId, defaultOption.helpIntentId, { event: { languageCode: 'en', name: defaultOption.helpIntentId }});
    // if (action.type === DETECT_INTENT_FAILURE) {
    //   props.showToast(`Failed to generate benefit option hint.`, { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    //   return;
    // } else {
    //   setSelectedHintText(action.response.queryResult.fulfillmentText);
    // }
  }

  const changeSelectedBenefitHint = async (option) => {
    setSelectedHintOption(option);
    setSelectedHintText(null);

    const action = await props.detectIntent(sessionId, option.helpIntentId, { event: { languageCode: 'en', name: option.helpIntentId }});
    if (action.type === DETECT_INTENT_FAILURE) {
      props.showToast(`Failed to generate benefit option hint.`, { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      return;
    } else {
      setSelectedHintText(action.response.queryResult.fulfillmentText);
    }
  }

  const updateTempLivingCost = async () => {
    setIsUpdatingBenefitPrice(true);

    if (topLevelInputThreeId) {
      const tempLivingPriceResp = await props.getTempLivingPriceByRegion( freeDownloadInfo.estimateInfo.destination.state, `${freeDownloadInfo.estimateInfo.destination.city}, ${freeDownloadInfo.estimateInfo.destination.state}`, topLevelInputThreeId );
      setTempLivingDaysCost(parseFloat(tempLivingPriceResp.response.median.replace('$', '')));
    } else {
      setTempLivingDaysCost(0);
    }


    setIsUpdatingBenefitPrice(false);
  }

  const updateHomefindingCost = async () => {
    setIsUpdatingBenefitPrice(true);

    // May need logic here in the future if recalculating homefinding cost based on number of children or adults is required.

    setIsUpdatingBenefitPrice(false);
  }

  const updateHhgCost = async () => {
    setIsUpdatingBenefitPrice(true);

    const homeType = (topLevelInputOneId === 1 || topLevelInputOneId === 2) ? 2 : 1;

    const packLoadMoveResp = await props.getPackLoadMovePrice( props.distance, homeType, topLevelInputTwoId );
    if (packLoadMoveResp.response) {
      setPackLoadCost(parseFloat(packLoadMoveResp.response.price.replace('$', '').replace(',', '')));
      setThirtyDayStorageCost(parseFloat(packLoadMoveResp.response.thirtyDayStorage.replace('$', '').replace(',', '')));
      setSixtyDayStorageCost(parseFloat(packLoadMoveResp.response.sixtyDayStorage.replace('$', '').replace(',', '')));
    } else {
      setPackLoadCost(0);
      setThirtyDayStorageCost(0);
      setSixtyDayStorageCost(0);
    }

    setIsUpdatingBenefitPrice(false);
  }

  // Recalculate costs for all saved benefits when dependencies change
  const recalculateSavedBenefitCosts = () => {
    if (!savedBenefits || savedBenefits.length === 0) return;

    const updatedBenefits = savedBenefits.map(savedBenefit => {
      const benefit = benefits.find(b => b.benefitNumber === savedBenefit.benefitNumber);
      if (!benefit || benefit.customTotal || benefit.customBenefit) {
        // Don't recalculate custom total or custom benefits
        return savedBenefit;
      }

      // Recalculate costs for each option by temporarily removing customCost
      const recalculatedOptions = savedBenefit.options.map(option => {
        const benefitOption = benefit.options.find(bo => bo.optionNumber === option.optionNumber);
        if (!benefitOption) return option;

        // Temporarily create option without customCost to force recalculation
        const optionWithoutCustomCost = { ...option };
        delete optionWithoutCustomCost.customCost;
        
        const newCost = getOptionCost(benefitOption, optionWithoutCustomCost);
        
        return {
          ...option,
          customCost: newCost
        };
      });

      return {
        ...savedBenefit,
        options: recalculatedOptions
      };
    });

    setSavedBenefits(updatedBenefits);
  };

  // Update hasSavedCustomCosts and savedBenefits when props.estimateInfo becomes available
  // This handles the case where component mounts before data is loaded (direct navigation)
  useEffect(() => {
    if (props.estimateInfo?.savedBenefits && !hasInitializedFromProps.current) {
      const hasCustomCosts = props.estimateInfo.savedBenefits.some(benefit => 
        benefit.options?.some(opt => opt.customCost !== undefined && opt.customCost !== null)
      );
      hasSavedCustomCosts.current = hasCustomCosts;
      
      // If savedBenefits is empty but props has data, sync it
      if (savedBenefits.length === 0 && props.estimateInfo.savedBenefits.length > 0) {
        setSavedBenefits(props.estimateInfo.savedBenefits);
      }
      
      hasInitializedFromProps.current = true;
    }
  }, [props.estimateInfo?.savedBenefits]);

  // Trigger recalculation when key dependencies change for saved benefits
  useEffect(() => {
    const currentDeps = {
      packLoadCost,
      tempLivingDaysCost,
      thirtyDayStorageCost,
      sixtyDayStorageCost,
      accompanyingAdults: freeDownloadInfo?.estimateInfo?.accompanyingAdults,
      topLevelInputFourId,
      topLevelInputFive,
      topLevelInputSix,
      topLevelInputSeven,
      topLevelInputEight,
      topLevelInputNine
    };

    // On first run, just store the initial values
    if (prevDependencyValues.current === null) {
      prevDependencyValues.current = currentDeps;
      // If we have saved customCosts, don't recalculate on initial load
      if (hasSavedCustomCosts.current) {
        return;
      }
    }

    // Check if any dependency actually changed from previous values
    const prevDeps = prevDependencyValues.current;
    const hasRealChange = 
      prevDeps.packLoadCost !== currentDeps.packLoadCost ||
      prevDeps.tempLivingDaysCost !== currentDeps.tempLivingDaysCost ||
      prevDeps.thirtyDayStorageCost !== currentDeps.thirtyDayStorageCost ||
      prevDeps.sixtyDayStorageCost !== currentDeps.sixtyDayStorageCost ||
      prevDeps.accompanyingAdults !== currentDeps.accompanyingAdults ||
      prevDeps.topLevelInputFourId !== currentDeps.topLevelInputFourId ||
      prevDeps.topLevelInputFive !== currentDeps.topLevelInputFive ||
      prevDeps.topLevelInputSix !== currentDeps.topLevelInputSix ||
      prevDeps.topLevelInputSeven !== currentDeps.topLevelInputSeven ||
      prevDeps.topLevelInputEight !== currentDeps.topLevelInputEight ||
      prevDeps.topLevelInputNine !== currentDeps.topLevelInputNine;

    // Update previous values for next comparison
    prevDependencyValues.current = currentDeps;

    // Only recalculate if:
    // 1. User has explicitly made changes OR
    // 2. Dependencies have actually changed AND we DON'T have saved customCosts to preserve
    const shouldRecalculate = hasUserMadeChanges.current || (hasRealChange && !hasSavedCustomCosts.current);

    // Once we've done a recalculation after user changes, we can allow future recalculations
    if (hasUserMadeChanges.current && hasRealChange) {
      hasSavedCustomCosts.current = false; // Allow future recalculations
    }

    // Wait for API calls to complete before recalculating
    if (!isUpdatingBenefitPrice && savedBenefits.length > 0 && shouldRecalculate) {
      recalculateSavedBenefitCosts();
    }
  }, [
    packLoadCost,
    tempLivingDaysCost,
    thirtyDayStorageCost,
    sixtyDayStorageCost,
    freeDownloadInfo?.estimateInfo?.accompanyingAdults,
    topLevelInputFourId,
    topLevelInputFive,
    topLevelInputSix,
    topLevelInputSeven,
    topLevelInputEight,
    topLevelInputNine
  ]);

  // Recalculate modal option costs when top-level inputs change
  useEffect(() => {
    if (selectedBenefit && selectedBenefitOptions && !selectedBenefit.customBenefit && !selectedBenefit.customTotal) {
      const recalculated = recalculateModalOptionCosts(selectedBenefitOptions, selectedBenefit);
      // Only update if costs actually changed to avoid infinite loops
      const costsChanged = recalculated.some((opt, idx) => {
        const existing = selectedBenefitOptions[idx];
        return existing && opt.customCost !== existing.customCost;
      });
      
      if (costsChanged) {
        setSelectedBenefitOptions(recalculated);
      }
    }
  }, [
    benefits,
    packLoadCost,
    tempLivingDaysCost,
    thirtyDayStorageCost,
    sixtyDayStorageCost,
    freeDownloadInfo?.estimateInfo?.accompanyingAdults,
    topLevelInputFourId,
    topLevelInputFive,
    topLevelInputSix,
    topLevelInputSeven,
    topLevelInputEight,
    topLevelInputNine
  ]);

  useEffect(() => {
    if (savedBenefits && props.estimateInfo?.savedBenefits) {
      let isDirty = false;

      // Deduplicate both sides to ensure fair comparison
      const cleanSavedBenefits = props.estimateInfo.savedBenefits.map(benefit => {
        if (benefit.benefitNumber === 9 && benefit.options) {
          const deduplicatedOptions = benefit.options.filter((opt, index, self) => 
            index === self.findIndex(o => o.optionNumber === opt.optionNumber)
          );
          return { ...benefit, options: deduplicatedOptions };
        }
        return benefit;
      });

      // Checking if benefits or options were removed or changed
      savedBenefits.map((draftBenefit) => {
        const savedBenefit = cleanSavedBenefits.find((esb) => esb.benefitNumber === draftBenefit.benefitNumber);
        if (!savedBenefit) {
          isDirty = true;
        } else {
          // Check if benefit-level cost changed (for customTotal benefits like Relocation Allowance)
          // Do this first, and skip option comparison for customTotal benefits
          const isCustomTotalBenefit = draftBenefit.cost != undefined || savedBenefit.cost != undefined;
          
          if (isCustomTotalBenefit) {
            // For customTotal benefits, only compare the cost and isTaxable, not options
            if (Math.abs(Number(draftBenefit.cost || 0) - Number(savedBenefit.cost || 0)) > 1) {
              isDirty = true;
            }
            if (!!draftBenefit.isTaxable !== !!savedBenefit.isTaxable) {
              isDirty = true;
            }
          } else {
            // For regular benefits, compare options
            draftBenefit.options.map((draftOption) => {
              const savedOption = savedBenefit.options.find((opt) => opt.optionNumber === draftOption.optionNumber);
              if (!savedOption) {
                isDirty = true;
              } else {
                // Check if selectionId changed
                if ((draftOption.selectionId || savedOption.selectionId) && draftOption.selectionId !== savedOption.selectionId) {
                  isDirty = true;
                }
                // Check if customCost changed significantly (ignore floating point differences < 1)
                if (draftOption.customCost !== undefined && savedOption.customCost !== undefined) {
                  const costDiff = Math.abs(Number(draftOption.customCost) - Number(savedOption.customCost));
                  if (costDiff > 1) {
                    isDirty = true;
                  }
                }
                // Check if customDescription changed (for custom benefits)
                if ((draftOption.customDescription || savedOption.customDescription) && 
                    draftOption.customDescription !== savedOption.customDescription) {
                  isDirty = true;
                }
              }
            })
            // Check if customLineCost or customLineDescription changed
            if (draftBenefit.customLineChecked !== savedBenefit.customLineChecked) {
              isDirty = true;
            }
            if (draftBenefit.customLineChecked && 
                (draftBenefit.customLineDescription !== savedBenefit.customLineDescription ||
                 Math.abs(Number(draftBenefit.customLineCost || 0) - Number(savedBenefit.customLineCost || 0)) > 1)) {
              isDirty = true;
            }
          }
        }
      })

      // Checking if benefits or options were added
      cleanSavedBenefits.map((savedBenefit) => {
        const draftBenefit = savedBenefits.find((sb) => sb.benefitNumber === savedBenefit.benefitNumber);
        if (!draftBenefit) {
          isDirty = true;
        } else {
          // Skip option comparison for customTotal benefits (they use benefit-level cost)
          const isCustomTotalBenefit = draftBenefit.cost != undefined || savedBenefit.cost != undefined;
          if (!isCustomTotalBenefit) {
            savedBenefit.options.map((savedOption) => {
              const draftOption = draftBenefit.options.find((opt) => opt.optionNumber === savedOption.optionNumber);
              if (!draftOption) {
                isDirty = true;
              } else {
                // Check if selectionId changed
                if ((draftOption.selectionId || savedOption.selectionId) && draftOption.selectionId !== savedOption.selectionId) {
                  isDirty = true;
                }
              }
            })
          }
        }
      })

      // Checking if top level inputs have changed
      if (((props.estimateInfo.topLevelInputOneId || topLevelInputOneId) && props.estimateInfo.topLevelInputOneId !== topLevelInputOneId) || 
        ((props.estimateInfo.topLevelInputTwoId || topLevelInputTwoId) && props.estimateInfo.topLevelInputTwoId !== topLevelInputTwoId) || 
        ((props.estimateInfo.topLevelInputThreeId || topLevelInputThreeId) && props.estimateInfo.topLevelInputThreeId !== topLevelInputThreeId) || 
        ((props.estimateInfo.topLevelInputFourId || topLevelInputFourId) && props.estimateInfo.topLevelInputFourId !== topLevelInputFourId) ||
        ((props.estimateInfo.topLevelInputFive || topLevelInputFive) && props.estimateInfo.topLevelInputFive !== topLevelInputFive) || 
        ((props.estimateInfo.topLevelInputSix || topLevelInputSix) && props.estimateInfo.topLevelInputSix !== topLevelInputSix) || 
        ((props.estimateInfo.topLevelInputSeven || topLevelInputSeven) && Number(props.estimateInfo.topLevelInputSeven) !== Number(topLevelInputSeven)) ||
        ((props.estimateInfo.topLevelInputEight || topLevelInputEight) && props.estimateInfo.topLevelInputEight !== topLevelInputEight) ||
        ((props.estimateInfo.topLevelInputNine || topLevelInputNine) && Number(props.estimateInfo.topLevelInputNine) !== Number(topLevelInputNine))
      ) {
        isDirty = true;
      }

      // Check to see if tax gross up status changed
      if (!!props.estimateInfo.applyTaxGrossUp !== !!applyTaxGrossUp) {
        isDirty = true;
      }

      // Check to see if gross up percentage changed
      if (props.estimateInfo.grossUpPercentage !== undefined && parseFloat(props.estimateInfo.grossUpPercentage) !== parseFloat(grossUpPercentage)) {
        isDirty = true;
      }

      setIsBenefitListDirty(isDirty);

      setParentBenefitListDirty(isDirty);
    } 
  }, [savedBenefits, props.estimateInfo?.savedBenefits, applyTaxGrossUp, grossUpPercentage]);

  useEffect(() => {
    if (topLevelInputOneId && topLevelInputTwoId && props.distance && props.distance > 0) {
      updateHhgCost();
    }
  }, [topLevelInputOneId, topLevelInputTwoId, props.distance]);

  useEffect(() => {
    if (topLevelInputThreeId && freeDownloadInfo && freeDownloadInfo.estimateInfo.destination) {
      updateTempLivingCost();
    }
  }, [topLevelInputThreeId, freeDownloadInfo?.estimateInfo?.destination?.city, freeDownloadInfo?.estimateInfo?.destination?.state]);

  // Force PDFDownloadLink to remount when accompanyingAdults changes
  // This ensures fresh closure references are captured for cost calculations
  useEffect(() => {
    const currentAccompanyingAdults = freeDownloadInfo?.estimateInfo?.accompanyingAdults;
    
    // Only trigger if this is an actual change (not initial mount) and we have benefits
    if (prevAccompanyingAdults.current !== undefined && 
        currentAccompanyingAdults !== prevAccompanyingAdults.current && 
        savedBenefits && savedBenefits.length > 0) {
      setIsUpdatingBenefitPrice(true);
      // Small delay to allow React to unmount the PDFDownloadLink before remounting
      setTimeout(() => {
        setIsUpdatingBenefitPrice(false);
      }, 100);
    }
    
    // Always update the ref for tracking
    prevAccompanyingAdults.current = currentAccompanyingAdults;
  }, [freeDownloadInfo?.estimateInfo?.accompanyingAdults]);

  useEffect(() => {
    if (topLevelInputFourId && freeDownloadInfo && freeDownloadInfo.perDiemRate && freeDownloadInfo.perDiemRate > 0 && freeDownloadInfo.flightCost) {
      updateHomefindingCost();
    }
  }, [topLevelInputThreeId]);

  useEffect(() => {
    if (updatedPolicyBenefits) {
      // Deduplicate custom benefit options when receiving from backend
      const cleanedBenefits = updatedPolicyBenefits.map(benefit => {
        if (benefit.benefitNumber === 9 && benefit.options) {
          // Deduplicate options for Additional Benefits
          const deduplicatedOptions = benefit.options.filter((opt, index, self) => 
            index === self.findIndex(o => o.optionNumber === opt.optionNumber)
          );
          return { ...benefit, options: deduplicatedOptions };
        }
        return benefit;
      });
      
      setSavedBenefits(cleanedBenefits);
      setApplyTaxGrossUp(updatedGrossUp);
    }
  }, [updatedPolicyBenefits]);

  useEffect(() => {
    if (props.estimateInfo) {
      setTopLevelInputOneId(props.estimateInfo.topLevelInputOneId || null);
      setTopLevelInputTwoId(props.estimateInfo.topLevelInputTwoId || null);
      setTopLevelInputThreeId(props.estimateInfo.topLevelInputThreeId || null);
      setTopLevelInputFourId(props.estimateInfo.topLevelInputFourId || null);
      setTopLevelInputFive(props.estimateInfo.topLevelInputFive || false);
      setTopLevelInputSix(props.estimateInfo.topLevelInputSix || false);
      setTopLevelInputSeven(props.estimateInfo.topLevelInputSeven || null);
      setTopLevelInputEight(props.estimateInfo.topLevelInputEight || false);
      setTopLevelInputNine(props.estimateInfo.topLevelInputNine || null);
      setApplyTaxGrossUp(props.estimateInfo.applyTaxGrossUp || false);
      setGrossUpPercentage(props.estimateInfo.grossUpPercentage || 60);
    }
  }, [props.estimateInfo?.topLevelInputOneId, props.estimateInfo?.topLevelInputTwoId, props.estimateInfo?.topLevelInputThreeId, props.estimateInfo?.topLevelInputFourId, props.estimateInfo?.topLevelInputFive, props.estimateInfo?.topLevelInputSix, props.estimateInfo?.topLevelInputSeven, props.estimateInfo?.topLevelInputEight, props.estimateInfo?.topLevelInputNine, props.estimateInfo?.applyTaxGrossUp, props.estimateInfo?.grossUpPercentage]);

  const staticBenefitsForCalculation = getBenefits(freeDownloadInfo.perDiemRate, freeDownloadInfo.perDiemMealRate, freeDownloadInfo.avgHomesalePrice, freeDownloadInfo.avgHomesalePriceOrigin, freeDownloadInfo.flightCost, freeDownloadInfo.homefindingDays, freeDownloadInfo.autoShipmentCost, props.distance);
  const grossUpAmount = getGrossUpAmount(staticBenefitsForCalculation, savedBenefits, topLevelInputFive, topLevelInputSix, topLevelInputSeven, topLevelInputEight, topLevelInputNine, freeDownloadInfo.avgHomesalePrice, freeDownloadInfo.avgHomesalePriceOrigin, applyTaxGrossUp, getOptionCost, grossUpPercentage);

  return (
    <Box position="relative">
        <Fragment>
          {isUpdatingSelections && (
            <Box className={classes.loadingOverlay}>
              <LogoSpinner size="large" />
            </Box>
          )}
          <Grid container direction="column">
            <Grid item>
              <Paper className={classes.moveGuideHeader}>
                <Box p={2.5}>
                  <Grid container direction="row">
                    <Grid item xs={5}>
                      <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-start'}}>
                        <Typography variant="h6">Benefit Selections</Typography>
                        <Box sx={{ paddingTop: '0px', display: 'flex', flexDirection: 'row' }}>
                            <Box sx={{paddingLeft: '20px', paddingBottom: '10px'}}>
                              <FormControlLabel
                                  control={
                                      <Checkbox
                                          checked={applyTaxGrossUp}
                                          onChange={(e) => setApplyTaxGrossUp(!applyTaxGrossUp)}
                                          size="small"
                                      />
                                  }
                                  disabled={lastDayHasPassed}
                                  label={`Apply Tax Gross Up (${grossUpPercentage}%)`}
                              />
                            </Box>
                            {!showTaxGrossUpInput && (
                              <>
                                <Box sx={{paddingLeft: '10px', paddingTop: '8px'}}>
                                  <Link component="button" variant="body2" onClick={() => setShowTaxGrossUpInput(true)}>Edit</Link>
                                </Box>
                              </>
                            )}
                            {showTaxGrossUpInput && (
                              <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                                <TextField
                                    id="name"
                                    className={classes.textField}
                                    label="Gross Up Percentage"
                                    value={grossUpPercentage}
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    onChange={(e) => setGrossUpPercentage(e.target.value)}
                                    disabled={lastDayHasPassed}
                                />
                                <Box sx={{paddingLeft: '10px', paddingTop: '8px'}}>
                                  <Link component="button" variant="body2" onClick={() => setShowTaxGrossUpInput(false)}>Done</Link>
                                </Box>
                              </Box>
                            )}
                        </Box>
                      </Box>
                      
                    </Grid>
                    <Grid item xs={2} container justify="center">
                      <Box mt={1} width="100%" textAlign="center">
                        <SelectionsCostBar 
                          savedBenefits={savedBenefits} 
                          benefits={benefits} 
                          distance={props.distance} 
                          applyTaxGrossUp={applyTaxGrossUp} 
                          topLevelInputFive={topLevelInputFive} 
                          topLevelInputSix={topLevelInputSix} 
                          topLevelInputSeven={topLevelInputSeven}
                          topLevelInputEight={topLevelInputEight}
                          topLevelInputNine={topLevelInputNine}
                          avgHomesalePrice={freeDownloadInfo.avgHomesalePrice}
                          avgHomesalePriceOrigin={freeDownloadInfo.avgHomesalePriceOrigin} 
                          getOptionCost={getOptionCost} 
                          grossUpPercentage={grossUpPercentage}
                        />
                      </Box>
                    </Grid>
                    <Grid item xs={5} container justify="flex-end" alignItems="flex-start">
                      {!savingEstimate && (
                        <Box sx={{marginTop: '10px'}}>
                          <Button 
                            size="small"
                            color="secondary" 
                            className={classes.button} 
                            onClick={() => resetBenefits()}
                            disabled={lastDayHasPassed}
                          >
                            Reset
                          </Button>
                          {policyId === null && isPremium && (
                            <Button variant="contained" 
                              size="small"
                              color="secondary" 
                              className={classes.button} 
                              onClick={() => props.exportEstimate(savedBenefits, applyTaxGrossUp, grossUpPercentage, topLevelInputOneId, topLevelInputTwoId, topLevelInputThreeId, topLevelInputFourId, topLevelInputFive, topLevelInputSix, topLevelInputSeven, topLevelInputEight, topLevelInputNine)} // Add back top level input saving
                            >
                              Export
                            </Button>
                          )}
                          {policyId === null && !isPremium && (
                            <>
                             {freeDownloadInfo.estimateInfo.origin.city && freeDownloadInfo.estimateInfo.destination.city && savedBenefits && (
                                <>
                                  {!isUpdatingBenefitPrice && (
                                    <PDFDownloadLink document={
                                      <DownloadableDoc 
                                          estimateInfo={freeDownloadInfo.estimateInfo} 
                                          savedBenefits={savedBenefits} 
                                          benefits={getBenefits(freeDownloadInfo.perDiemRate, freeDownloadInfo.perDiemMealRate, freeDownloadInfo.avgHomesalePrice, freeDownloadInfo.avgHomesalePriceOrigin, freeDownloadInfo.flightCost, freeDownloadInfo.homefindingDays, freeDownloadInfo.autoShipmentCost, freeDownloadInfo.distance)} 
                                          distance={freeDownloadInfo.distance} 
                                          applyTaxGrossUp={applyTaxGrossUp} 
                                          perDiemRate={freeDownloadInfo.perDiemRate}
                                          perDiemMealRate={freeDownloadInfo.perDiemMealRate}
                                          avgHomesalePrice={freeDownloadInfo.avgHomesalePrice}
                                          avgHomesalePriceOrigin={freeDownloadInfo.avgHomesalePriceOrigin}
                                          flightCost={freeDownloadInfo.flightCost}
                                          homefindingDays={freeDownloadInfo.homefindingDays}
                                          tempLivingDaysCost={tempLivingDaysCost}
                                          autoShipmentCost={freeDownloadInfo.autoShipmentCost}
                                          topLevelInputOneId={topLevelInputOneId}
                                          topLevelInputTwoId={topLevelInputTwoId}
                                          topLevelInputThreeId={topLevelInputThreeId}
                                          topLevelInputFourId={topLevelInputFourId}
                                          topLevelInputFive={topLevelInputFive}
                                          topLevelInputSix={topLevelInputSix}
                                          topLevelInputSeven={topLevelInputSeven}
                                          topLevelInputEight={topLevelInputEight}
                                          topLevelInputNine={topLevelInputNine}
                                          grossUpAmount={grossUpAmount}
                                          getOptionCost={getOptionCost}
                                          grossUpPercentage={grossUpPercentage}
                                      />
                                    } fileName="Estimate Summary.pdf">
                                        {({ blob, url, loading, error }) => {
                                          if (loading) {
                                            return 'Loading document...';
                                          } else if (error) {
                                            console.log('Error generating PDF:', error);
                                            return 'Error generating document...';
                                          } else {
                                            return <Button variant="contained" size="small" color="primary" className={classes.longButton} >Export as PDF</Button>;
                                          }
                                        }}
                                    </PDFDownloadLink>
                                  )}
                                  {isUpdatingBenefitPrice && (
                                    <Spinner size="small" className={classes.spinner} />
                                  )}
                                </>
                                
                             )}
                             {(!freeDownloadInfo.estimateInfo.origin.city || !freeDownloadInfo.estimateInfo.destination.city) && (
                                <Button variant="contained" size="small" color="primary" className={classes.longButton} disabled>Export as PDF</Button>
                              )}
                            </>
                          )}
                          {isPremium && (
                            <Button variant="contained" 
                              size="small"
                              color="secondary" 
                              className={classes.button}
                              disabled={(!isHeaderDirty && !isBenefitListDirty) || lastDayHasPassed}
                              onClick={() => props.saveEstimate(savedBenefits, applyTaxGrossUp, grossUpPercentage, false, topLevelInputOneId, topLevelInputTwoId, topLevelInputThreeId, topLevelInputFourId, topLevelInputFive, topLevelInputSix, topLevelInputSeven, topLevelInputEight, topLevelInputNine)} // Add back top level input saving
                            >
                              Save
                            </Button>
                          )}
                          {policyId === null && isPremium && (
                            <Button variant="contained" 
                              size="small"
                              color="primary" 
                              className={classes.longButton} 
                              onClick={() => props.generateAuth(benefits, savedBenefits, topLevelInputFive, topLevelInputSix, topLevelInputSeven, topLevelInputEight, topLevelInputNine, applyTaxGrossUp, getOptionCost, grossUpPercentage)}
                            >
                              Generate Auth
                            </Button>
                          )}
                        </Box>
                      )}
                      {savingEstimate && (
                        <Box sx={{marginTop: '10px'}}>
                          <Spinner/>
                        </Box>
                      )}
                    </Grid>
                  </Grid>
                </Box>
              </Paper>
            </Grid>
            <Grid item className={classes.benefitListContainer}>
              <Grid container direction="column" wrap="nowrap">
                {
                  benefits.map((benefit) => {
                    let totalBenefitCost = 0;
                    let currentSavedBenefit = savedBenefits.find((sb) => sb.benefitNumber === benefit.benefitNumber);
                    let showNeedsOptions = false;

                    if (benefit.customTotal) {
                      if (currentSavedBenefit) {
                        totalBenefitCost = currentSavedBenefit.cost;
                      } else {
                        totalBenefitCost = 3000;
                      }
                    } else if (benefit.customBenefit) {
                      if (currentSavedBenefit) {
                        // Deduplicate options before calculating total to prevent double-counting
                        const deduplicatedOptions = currentSavedBenefit.options.filter((opt, index, self) => 
                          index === self.findIndex(o => o.optionNumber === opt.optionNumber)
                        );
                        totalBenefitCost = deduplicatedOptions.reduce((total, o) => total + Number(o.customCost), 0);
                      } else {
                        totalBenefitCost = 0;
                      }
                    } else {
                      if (currentSavedBenefit) {
                        totalBenefitCost = benefit.options.filter((opt) => currentSavedBenefit.options.find((csbo) => csbo.optionNumber === opt.optionNumber)).reduce((total, o) => total + getOptionCost(o, currentSavedBenefit.options.find((csbo) => csbo.optionNumber === o.optionNumber)), 0);
                        totalBenefitCost += currentSavedBenefit.customLineChecked ? Number(currentSavedBenefit.customLineCost) : 0;
                      } else {
                        totalBenefitCost = benefit.options.reduce((total, o) => total + getOptionCost(o, null), 0);
                      }
                    }

                    if ((benefit.benefitNumber === 0 && (!topLevelInputOneId || !topLevelInputTwoId)) || (benefit.benefitNumber === 2 && !topLevelInputThreeId) || (benefit.benefitNumber === 3 && !topLevelInputFourId)) {
                      showNeedsOptions = true;
                    }

                    if (props.reloPolicy && props.reloPolicy === 'Renter' && benefit.isOwnerOnly) return null;

                    if (props.reloPolicy && props.reloPolicy === 'Homeowner' && benefit.isRenterOnly) return null;

                    if (benefit.customBenefit && !isPremium) return null;

                    return (
                      <Accordion 
                        key={benefit.benefitNumber}
                        expanded={expandedBenefitId === benefit.benefitNumber}
                        className={expandedBenefitId === benefit.benefitNumber ? classes.benefitSelected : null}
                        onChange={handleAccordionChange(benefit.benefitNumber)}
                      >
                        <AccordionSummary
                          expandIcon={<ExpandMoreIcon />}
                          // style={{ cursor: !hasSelectedOptions && 'default' }} // inline to ensure override
                        >
                          <Grid container alignItems="center" spacing={1}>
                            <Grid item xs={1} style={{ backgroundImage: `url(${benefit.imageUrl})` }}
                              className={classNames(classes.benefitImage)}
                            />
                            <Grid item xs={11}>
                              <Box mr={0}>
                                <Grid container>
                                  <Grid item xs={7}>
                                    <Typography variant="subtitle1">
                                      {benefit.name}
                                    </Typography>
                                    <Box lineHeight="1">
                                      <Typography variant="caption">
                                        {benefit.secondaryText}
                                      </Typography>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={2}>
                                    {showNeedsOptions && (
                                      <Box sx={{ paddingTop: '10px'}}>
                                        <Typography variant="subtitle1" color="error">(Inputs Required)</Typography>
                                      </Box>
                                    )}
                                  </Grid>
                                  <Grid item xs={1}>
                                    <Box sx={{ paddingTop: '10px'}}>
                                        <Typography variant="subtitle1">{currentSavedBenefit ? displayCost(totalBenefitCost, CostUnit.CURRENCY) : <div>&mdash;&mdash;&mdash;</div>}</Typography>
                                    </Box>
                                  </Grid>
                                  <Grid item xs={1}>
                                    {currentSavedBenefit && (
                                        <Box sx={{ paddingTop: '15px' }}>
                                            <FontAwesomeIcon icon="check-circle" />
                                        </Box>
                                    )}
                                  </Grid>
                                  <Grid item xs={1}>
                                    <Box sx={{ paddingTop: '10px'}}>
                                        {renderBenefitRowAction(benefit, currentSavedBenefit)}
                                    </Box>
                                  </Grid>
                                </Grid>
                              </Box>
                            </Grid>
                          </Grid>
                        </AccordionSummary>
                        <AccordionDetails style={{ marginTop: 0 }}>
                          {
                            (benefit.options.length > 0) &&
                              <Grid container>
                                <Grid item xs={1} />
                                <Grid item xs={11}>
                                  <Box mr={4}>
                                    <Grid container direction="column" spacing={4}>
                                      {
                                        benefit.options.map((opt) => renderOption(opt, benefit, savedBenefits.find((sb) => sb.benefitNumber === benefit.benefitNumber), savedBenefits.find((sb) => sb.benefitNumber === benefit.benefitNumber) && savedBenefits.find((sb) => sb.benefitNumber === benefit.benefitNumber).options.find((o) => o.optionNumber === opt.optionNumber)))
                                      }

                                      {currentSavedBenefit && currentSavedBenefit.customLineChecked && (
                                        <Grid item container direction="row" className={classes.optionRow}>
                                          <Grid item xs={8} container direction="column">
                                            <Grid item>
                                              <Box sx={{display: 'flex', flexDirection: 'row'}}>
                                                <Typography variant="body2">
                                                  {currentSavedBenefit.customLineDescription}
                                                </Typography>
                                              </Box>
                                            </Grid>
                                          </Grid>
                                          <Grid item container xs={2} justify="flex-end" alignContent="center">
                                            <Typography variant="caption">{displayCost(Number(currentSavedBenefit.customLineCost), CostUnit.CURRENCY)}</Typography>
                                          </Grid>
                                          <Grid item container xs={2} justify="flex-start" alignContent="center">
                                            <Box pl={2}>
                                              <Typography variant="caption" color="secondary"><FontAwesomeIcon icon="check-circle" /> Confirmed</Typography>
                                            </Box>
                                          </Grid>
                                        </Grid>
                                      )}
                                    </Grid>
                                  </Box>
                                </Grid>
                              </Grid>
                          }
                        </AccordionDetails>
                      </Accordion>
                    );
                  })
                }
              </Grid>
            </Grid>
          </Grid>
        </Fragment> 

        {showGeneralHintModal && (
          <Dialog
            open={showGeneralHintModal}
            onClose={() => { setShowGeneralHintModal(false); setSelectedHintOption(null); setSelectedHintText(null); }}
            maxWidth="sm"
            fullWidth>
              <DialogTitle>
                {selectedBenefit.name}
                <IconButton aria-label="close" className={classes.closeButton} onClick={() => { setShowGeneralHintModal(false); setSelectedHintOption(null); setSelectedHintText(null); }}>
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent classes={{ root: classes.content }}>
                <Box
                  marginY="1px"
                  marginX={0}
                  paddingY={1}
                  paddingX={2}
                  maxWidth="100%"
                  borderRadius="20px"
                  bgcolor={'#EAEAEA'}
                  color={''}
                >
                  {`${selectedBenefit.generalBenefitHelp}`}
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'row'}}>
                  {selectedBenefit.options.map((sbo) => {
                    if (sbo.helpIntentId == null) return null;
                    
                    return (
                      <>
                        <Box sx={{ padding: '16px 16px 16px 0px', width: '275px', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                          {(!selectedHintOption || (selectedHintOption && sbo.optionNumber !== selectedHintOption.optionNumber)) && (
                            <Button variant="outlined" size="large" color="primary" onClick={() => changeSelectedBenefitHint(sbo)} disabled={false}>{sbo.description}</Button>
                          )}
                          {(selectedHintOption && sbo.optionNumber === selectedHintOption.optionNumber) && (
                            <Button variant="contained" size="large" color="primary" disabled={false}>{sbo.description}</Button>
                          )}
                        </Box>

                        {sbo.optionNumber === 21 && (
                          <Box sx={{ padding: '16px 16px 16px 0px', width: '275px', display: 'flex', flexDirection: 'row', justifyContent: 'center'}}>
                            <Button variant={(selectedHintOption && selectedHintOption.optionNumber === 33) ? 'contained' : 'outlined'} size="large" color="primary" onClick={() => changeSelectedBenefitHint({helpIntentId: 'direct_reimbursement_gross_up_hint_v1', optionNumber: 33})} disabled={false}>Direct Reimbursement (Subject to Gross Up)</Button>
                          </Box>
                        )}
                      </>
                    )
                  })}
                </Box>
                {selectedHintText == null && <Spinner/>}
                {selectedHintText != null && selectedHintText.length > 0 && (
                  <Box
                    marginY="1px"
                    marginX={0}
                    paddingY={1}
                    paddingX={2}
                    maxWidth="100%"
                    borderRadius="20px"
                    bgcolor={'#EAEAEA'}
                    color={''}
                  >
                    {selectedHintText}
                  </Box>
                )}
              </DialogContent>
          </Dialog>
        )}

        {showHintModal && (
          <Dialog
            open={showHintModal}
            onClose={() => { setShowHintModal(false); setHintText(null); setHintHeader(null); }}
            maxWidth="sm"
            fullWidth>
              <DialogTitle>
                {hintHeader}
                <IconButton aria-label="close" className={classes.closeButton} onClick={() => { setShowHintModal(false); setHintText(null); setHintHeader(null); }}>
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent classes={{ root: classes.content }}>
                {!hintText && <Spinner/>}
                {hintText && <Typography variant="subtitle1">{hintText}</Typography>}
              </DialogContent>
          </Dialog>
        )}

        {selectedBenefit && (
          <Dialog
            open={showUpdateModal}
            onClose={() => setShowUpdateModal(false)}
            maxWidth="md"
            fullWidth>
              <DialogTitle>
                {!selectedBenefit.generalBenefitHelp && (
                  <>
                    {selectedBenefit.name}
                  </>
                )}
                {selectedBenefit.generalBenefitHelp && (
                  <Box sx={{ display: 'flex', flexDirection: 'row'}}>
                    <Box>
                      {selectedBenefit.name}
                    </Box>
                    {selectedBenefit.generalBenefitHelp && (
                      <Box sx={{marginLeft: '5px'}}>
                        <Box sx={{cursor: 'pointer'}} onClick={() => (selectedBenefit.benefitNumber !== 4 && selectedBenefit.benefitNumber !== 6) ? generalBenefitHelpSelected(selectedBenefit) : helpModalOpened(selectedBenefit.options[0]) }>
                          <FontAwesomeIcon color={'primary'} icon={['fas', 'question-circle']} />
                        </Box>
                      </Box>
                    )}
                  </Box>
                )}
                <IconButton aria-label="close" className={classes.closeButton} onClick={() => setShowUpdateModal(false)}>
                  <CloseIcon />
                </IconButton>
              </DialogTitle>
              <DialogContent classes={{ root: classes.content }}>
                {isUpdatingBenefitPrice && (
                  <Box className={classes.loadingOverlay}>
                    <LogoSpinner size="large" />
                  </Box>
                )}
                {(selectedBenefit.topLevelInputOne || selectedBenefit.topLevelInputTwo) && (
                  <>
                    <Box sx={{ display: 'flex', flexDirection: 'row', marginBottom: '20px' }}>
                      {selectedBenefit.topLevelInputOne && (
                        <Box sx={{ marginRight: '10px', minWidth: '200px'}}>
                          <TextField
                              id="topLevelInputOneId"
                              select
                              label={selectedBenefit.topLevelInputOne.name}
                              className={classes.textField}
                              onChange={(e) => { 
                                hasUserMadeChanges.current = true;
                                setTopLevelInputOneId(e.target.value);  
                              }}
                              value={topLevelInputOneId ? topLevelInputOneId : ''}
                              fullWidth={true}
                              variant="outlined"
                              size="small"
                              disabled={lastDayHasPassed}
                          >
                            {selectedBenefit.topLevelInputOne.options.map((topOpt) => <MenuItem value={topOpt.id} key={topOpt.id}>{topOpt.label}</MenuItem>)}
                          </TextField>
                        </Box>
                      )}
                      {selectedBenefit.topLevelInputTwo && (
                        <Box sx={{ minWidth: '200px'}}>
                          <TextField
                              id="topLevelInputTwoId"
                              select
                              label={selectedBenefit.topLevelInputTwo.name}
                              className={classes.textField}
                              onChange={(e) => { 
                                hasUserMadeChanges.current = true;
                                setTopLevelInputTwoId(e.target.value);  
                              }}
                              value={topLevelInputTwoId ? topLevelInputTwoId : ''}
                              fullWidth={true}
                              variant="outlined"
                              size="small"
                              disabled={lastDayHasPassed}
                          >
                            {selectedBenefit.topLevelInputTwo.options.map((topOpt) => {
                              if (selectedBenefit.topLevelInputTwo.id === 'numBedrooms' && (topLevelInputOneId === 1 || topLevelInputOneId === 2) && (topOpt.id === 3 || topOpt.id === 4 || topOpt.id === 5)) {
                                return null;
                              } else {
                                return <MenuItem value={topOpt.id} key={topOpt.id}>{topOpt.label}</MenuItem>;
                              }
                            })}
                          </TextField>
                        </Box>
                      )}
                    </Box>
                    {(topLevelInputOneId == null || topLevelInputTwoId == null) && (
                      <Box sx={{paddingTop: '10px', paddingBottom: '10px'}}>
                        <Typography variant="subtitle1" color="error">The above inputs must be selected for the benefit options to calculate.</Typography>
                      </Box>
                    )}
                  </>
                )}
                {selectedBenefit.topLevelInputThree && (
                  <>
                    <Box sx={{ display: 'flex', flexDirection: 'row', marginBottom: '20px' }}>
                      <Box sx={{ minWidth: '200px'}}>
                        <TextField
                            id="topLevelInputThreeId"
                            select
                            label={selectedBenefit.topLevelInputThree.name}
                            className={classes.textField}
                            onChange={(e) => { 
                              hasUserMadeChanges.current = true;
                              setTopLevelInputThreeId(e.target.value);  
                            }}
                            value={topLevelInputThreeId ? topLevelInputThreeId : ''}
                            fullWidth={true}
                            variant="outlined"
                            size="small"
                            disabled={lastDayHasPassed}
                        >
                          {selectedBenefit.topLevelInputThree.options.map((topOpt) => {
                              return <MenuItem value={topOpt.id} key={topOpt.id}>{topOpt.label}</MenuItem>;
                          })}
                        </TextField>
                      </Box>
                    </Box>
                    {topLevelInputThreeId == null && (
                      <Box sx={{paddingTop: '10px', paddingBottom: '10px'}}>
                        <Typography variant="subtitle1" color="error">The above inputs must be selected for the benefit options to calculate.</Typography>
                      </Box>
                    )}
                  </>
                )}
                {selectedBenefit.topLevelInputFour && (
                  <>
                    <Box sx={{ display: 'flex', flexDirection: 'row', marginBottom: '20px' }}>
                      <Box sx={{ minWidth: '200px'}}>
                        <TextField
                            id="topLevelInputFourId"
                            select
                            label={selectedBenefit.topLevelInputFour.name}
                            className={classes.textField}
                            onChange={(e) => { 
                              hasUserMadeChanges.current = true;
                              setTopLevelInputFourId(e.target.value);  
                            }}
                            value={topLevelInputFourId ? topLevelInputFourId : ''}
                            fullWidth={true}
                            variant="outlined"
                            size="small"
                            disabled={lastDayHasPassed}
                        >
                          {selectedBenefit.topLevelInputFour.options.map((topOpt) => {
                              return <MenuItem value={topOpt.id} key={topOpt.id}>{topOpt.label}</MenuItem>;
                          })}
                        </TextField>
                      </Box>
                    </Box>
                    {topLevelInputFourId == null && (
                      <Box sx={{paddingTop: '10px', paddingBottom: '10px'}}>
                        <Typography variant="subtitle1" color="error">The above input must be selected for the benefit options to calculate.</Typography>
                      </Box>
                    )}
                  </>
                )}
                {/* Home Purchasing - Custom Top Level Inputs */}
                {selectedBenefit.benefitNumber === 4 && (
                  <>
                    <Box sx={{ display: 'flex', flexDirection: 'row', marginBottom: '16px' }}>
                      <Button disabled={lastDayHasPassed} color="secondary" variant="contained" style={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px', backgroundColor: !topLevelInputEight ? '#5D9878' : '#ffffff', '&:hover': { backgroundColor: !topLevelInputEight ? '#416A54' : '#faf8f2' }, color: !topLevelInputEight ? '#ffffff' : '#080600' }} onClick={() => { hasUserMadeChanges.current = true; setTopLevelInputEight(false); }}> {`Use location-based value (${displayCost((freeDownloadInfo.avgHomesalePrice), CostUnit.CURRENCY)})`} </Button>
                      <Button disabled={lastDayHasPassed} color="secondary" variant="contained" style={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px', backgroundColor: topLevelInputEight ? '#5D9878' : '#ffffff', '&:hover': { backgroundColor: topLevelInputEight ? '#416A54' : '#faf8f2' }, color: topLevelInputEight ? '#ffffff' : '#080600' }} onClick={() => { hasUserMadeChanges.current = true; setTopLevelInputEight(true); }}> Enter custom value </Button>
                    </Box>
                    {topLevelInputEight && (
                      <Box sx={{marginLeft: '12px', marginBottom: '16px'}}>
                        <TextField
                          id="topLevelInputNine"
                          label={'Custom Value'}
                          className={classes.textField}
                          onChange={(e) => { hasUserMadeChanges.current = true; setTopLevelInputNine(e.target.value); }}
                          value={topLevelInputNine}
                          fullWidth={true}
                          variant="outlined"
                          size="small"
                          type="number"
                          InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                          }}
                          disabled={lastDayHasPassed}
                      />
                      </Box>
                    )}
                  </>
                )}
                {/* Home Sale - Custom Top Level Inputs */}
                {selectedBenefit.benefitNumber === 5 && (
                  <>
                    <Box sx={{ display: 'flex', flexDirection: 'row', marginBottom: '16px' }}>
                      <Button disabled={lastDayHasPassed} color="secondary" variant="contained" style={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px', backgroundColor: !topLevelInputFive ? '#5D9878' : '#ffffff', '&:hover': { backgroundColor: !topLevelInputFive ? '#416A54' : '#faf8f2' }, color: !topLevelInputFive ? '#ffffff' : '#080600' }} onClick={() => { hasUserMadeChanges.current = true; setTopLevelInputFive(false); }}> Tax-protected homesale program </Button>
                      <Button disabled={lastDayHasPassed} color="secondary" variant="contained" style={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px', backgroundColor: topLevelInputFive ? '#5D9878' : '#ffffff', '&:hover': { backgroundColor: topLevelInputFive ? '#416A54' : '#faf8f2' }, color: topLevelInputFive ? '#ffffff' : '#080600' }} onClick={() => { hasUserMadeChanges.current = true; setTopLevelInputFive(true); }}> Direct reimbursement (subject to gross up) </Button>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row', marginBottom: '16px' }}>
                      <Button disabled={lastDayHasPassed} color="secondary" variant="contained" style={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px', backgroundColor: !topLevelInputSix ? '#5D9878' : '#ffffff', '&:hover': { backgroundColor: !topLevelInputSix ? '#416A54' : '#faf8f2' }, color: !topLevelInputSix ? '#ffffff' : '#080600' }} onClick={() => { hasUserMadeChanges.current = true; setTopLevelInputSix(false); }}> {`Use location-based value (${displayCost((freeDownloadInfo.avgHomesalePriceOrigin), CostUnit.CURRENCY)})`} </Button>
                      <Button disabled={lastDayHasPassed} color="secondary" variant="contained" style={{ maxHeight: '40px', marginLeft: '12px', marginTop: '8px', backgroundColor: topLevelInputSix ? '#5D9878' : '#ffffff', '&:hover': { backgroundColor: topLevelInputSix ? '#416A54' : '#faf8f2' }, color: topLevelInputSix ? '#ffffff' : '#080600' }} onClick={() => { hasUserMadeChanges.current = true; setTopLevelInputSix(true); }}> Enter custom value </Button>
                    </Box>
                    {topLevelInputSix && (
                      <Box sx={{marginLeft: '12px', marginBottom: '16px'}}>
                        <TextField
                          id="topLevelInputSeven"
                          label={'Custom Value'}
                          className={classes.textField}
                          onChange={(e) => { hasUserMadeChanges.current = true; setTopLevelInputSeven(e.target.value); }}
                          value={topLevelInputSeven}
                          fullWidth={true}
                          variant="outlined"
                          size="small"
                          type="number"
                          InputProps={{
                            startAdornment: <InputAdornment position="start">$</InputAdornment>,
                          }}
                          disabled={lastDayHasPassed}
                        />
                      </Box>
                    )}
                  </>
                )}
                {selectedBenefit.benefitNumber === 7 && (
                  <Box sx={{paddingBottom: '10px'}}>
                    <Hint>Flight cost and per diem are calculated using the entire accompanying family.</Hint>
                  </Box>
                )}
                <Box sx={{display: 'flex', flexDirection: 'column'}}>
                  {selectedBenefit.options.map((opt) => {
                    let selectedOption = selectedBenefitOptions.find((sbo) => sbo.optionNumber === opt.optionNumber);

                    let optDescription = opt.description;
                    if (opt.optionNumber === 21 && topLevelInputFive) {
                      optDescription = 'Direct reimbursement (subject to gross up)';
                    }

                    return (
                      <Box sx={{borderTop: '2px solid', backgroundColor: selectedOption ? '#f5f7f7' : undefined}}>
                        {!selectedBenefit.customBenefit && (
                          <Grid container>
                            <Grid item xs={4}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={selectedOption}
                                    disabled={lastDayHasPassed}
                                    onChange={(e) => setBenOptionSelection(e.target.checked, opt)}
                                  />
                                }
                                label={optDescription}
                              />
                            </Grid>
                            <Grid item xs={4}>
                              <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center', marginTop: '8px', marginBottom: '8px'}}>
                                {opt.selections && (
                                    <TextField
                                        id="optionSelection"
                                        select
                                        label=""
                                        className={classes.textField}
                                        onChange={(e) => { 
                                          setBenOptionDropdown(opt, e.target.value);  
                                        }}
                                        value={selectedOption ? selectedOption.selectionId : 1}
                                        fullWidth={true}
                                        variant="outlined"
                                        size="small"
                                        disabled={!selectedOption || lastDayHasPassed}
                                    >
                                      {opt.selections.map((os) => <MenuItem value={os.selectionId} key={os.selectionId}>{os.text}</MenuItem>)}
                                    </TextField>
                                )}
                                {selectedBenefit.customTotal && (
                                  <FormControlLabel
                                    control={
                                      <Checkbox
                                        checked={customTotalIsTaxable}
                                        disabled={lastDayHasPassed}
                                        onChange={(e) => setCustomTotalIsTaxable(e.target.checked)}
                                      />
                                    }
                                    label={'Is Grossed Up'}
                                  />
                                )}
                                {opt.freeNumberField && (
                                  <TextField
                                    id="optionFreeNumber"
                                    label={opt.freeNumberFieldLabel}
                                    className={classes.textField}
                                    onChange={(e) => setBenOptionDropdown(opt, e.target.value)}
                                    value={selectedOption ? selectedOption.selectionId : opt.freeNumberFieldDefault}
                                    fullWidth={true}
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    disabled={lastDayHasPassed}
                                  />
                                )}
                              </Box>
                            </Grid>
                            <Grid item xs={4}>
                              {!selectedBenefit.customTotal && (
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', marginTop: '8px'}}>
                                  <Typography variant="subtitle1" color={selectedOption ? 'secondary' : undefined}>{displayCost(getOptionCost(opt, selectedOption), CostUnit.CURRENCY)}</Typography>
                                </Box>
                              )}
                              {selectedBenefit.customTotal && (
                                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', paddingTop: '5px', paddingBottom: '5px'}}>
                                  <TextField
                                      id="customTotal"
                                      label=""
                                      className={classes.textField}
                                      onChange={(e) => setCustomTotal(e.target.value)}
                                      value={customTotal}
                                      fullWidth={true}
                                      variant="outlined"
                                      size="small"
                                      type="number"
                                      disabled={lastDayHasPassed}
                                      InputProps={{
                                        startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                      }}
                                  />
                                </Box>
                              )}
                            </Grid>
                          </Grid>
                        )}
                        {selectedBenefit.customBenefit && (
                          <Grid container>
                            <Grid item xs={4}>
                              <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingTop: '10px', paddingBottom: '10px'}}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      checked={selectedOption}
                                      disabled={lastDayHasPassed}
                                      onChange={(e) => setBenOptionSelection(e.target.checked, opt)}
                                    />
                                  }
                                  label={''}
                                />
                                <TextField
                                    id="customTotal"
                                    label="Benefit Name"
                                    className={classes.textField}
                                    onChange={(e) => opt.optionNumber === 28 ? setCustomLineItemOneText(e.target.value) : (opt.optionNumber === 29 ? setCustomLineItemTwoText(e.target.value) : setCustomLineItemThreeText(e.target.value))}
                                    value={opt.optionNumber === 28 ? customLineItemOneText : (opt.optionNumber === 29 ? customLineItemTwoText : customLineItemThreeText)}
                                    fullWidth={true}
                                    variant="outlined"
                                    size="small"
                                    type="text"
                                    disabled={lastDayHasPassed}
                                />
                              </Box>
                            </Grid>
                            <Grid item xs={4}>

                            </Grid>
                            <Grid item xs={4}>
                              <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', paddingTop: '5px', paddingBottom: '5px'}}>
                                <TextField
                                    id="customTotal"
                                    label=""
                                    className={classes.textField}
                                    onChange={(e) => opt.optionNumber === 28 ? setCustomLineItemOneCost(e.target.value) : (opt.optionNumber === 29 ? setCustomLineItemTwoCost(e.target.value) : setCustomLineItemThreeCost(e.target.value))}
                                    value={opt.optionNumber === 28 ? customLineItemOneCost : (opt.optionNumber === 29 ? customLineItemTwoCost : customLineItemThreeCost)}
                                    fullWidth={true}
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    disabled={lastDayHasPassed}
                                    InputProps={{
                                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                    }}
                                />
                              </Box>
                            </Grid>
                          </Grid>
                        )}
                      </Box>
                    )
                  })}
                  {!selectedBenefit.customBenefit && !selectedBenefit.customTotal && (
                    <Box sx={{borderTop: '2px solid', backgroundColor: customLineChecked ? '#f5f7f7' : undefined}}>
                      <Grid container>
                        <Grid item xs={4}>
                          <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingTop: '10px', paddingBottom: '10px'}}>
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    checked={customLineChecked}
                                    disabled={lastDayHasPassed}
                                    onChange={(e) => setCustomLineChecked(e.target.checked)}
                                  />
                                }
                                label={<TextField
                                  id="customTotal"
                                  label="Benefit Name"
                                  className={classes.textField}
                                  onChange={(e) => setCustomLineDescription(e.target.value)}
                                  value={customLineDescription}
                                  fullWidth={true}
                                  variant="outlined"
                                  size="small"
                                  type="text"
                                  disabled={lastDayHasPassed}
                              />}
                              />
                              
                            </Box>
                        </Grid>
                        <Grid item xs={4}>

                        </Grid>
                        <Grid item xs={4}>
                            <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', paddingTop: '5px', paddingBottom: '5px'}}>
                              <Box sx={{ maxWidth: '125px' }}>
                                <TextField
                                    id="customTotal"
                                    label=""
                                    className={classes.textField}
                                    onChange={(e) => setCustomLineCost(e.target.value)}
                                    value={customLineCost}
                                    variant="outlined"
                                    size="small"
                                    type="number"
                                    disabled={lastDayHasPassed}
                                    InputProps={{
                                      startAdornment: <InputAdornment position="start">$</InputAdornment>,
                                    }}
                                />
                              </Box>
                            </Box>
                        </Grid>
                      </Grid>
                    </Box>
                  )}
                </Box>
                <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', borderTop: '2px solid', paddingTop: '10px'}}>
                  <Box sx={{paddingRight: '10px'}}>
                    <Typography variant="subtitle1">Selected Total: </Typography>
                  </Box>
                  {!selectedBenefit.customBenefit && (
                    <>
                      {!selectedBenefit.customTotal && (
                        <Typography variant="subtitle1" color="secondary">{displayCost(selectedBenefitOptions.reduce((total, o) => total + getOptionCost(selectedBenefit.options.find((sbo) => sbo.optionNumber === o.optionNumber), o), 0) + (customLineChecked ? Number(customLineCost) : 0), CostUnit.CURRENCY)}</Typography>
                      )}
                      {selectedBenefit.customTotal && (
                        <Typography variant="subtitle1" color="secondary">{displayCost(Number(customTotal), CostUnit.CURRENCY)}</Typography>
                      )}
                    </>
                  )}
                  {selectedBenefit.customBenefit && (
                    <Typography variant="subtitle1" color="secondary">{displayCost(Number(customLineItemOneCost) + Number(customLineItemTwoCost) + Number(customLineItemThreeCost), CostUnit.CURRENCY)}</Typography>
                  )}
                  
                </Box>
              </DialogContent>
              <DialogActions>
                {savedBenefits.find((sb) => sb.benefitNumber === selectedBenefit.benefitNumber && !isLoading) && (
                  <Grid container justify="flex-end">
                    <Box sx={{padding: '12px'}}>
                      <Button disabled={lastDayHasPassed} variant="outlined" size="large" color="primary" onClick={() => disableBenefit()}>Disable Benefit</Button>
                    </Box>
                    <Box sx={{padding: '12px'}}>
                      <Button disabled={lastDayHasPassed} variant="contained" size="large" color="primary" onClick={() => updateBenefit()}>Update Benefit</Button>
                    </Box>
                  </Grid>
                )}
                {!savedBenefits.find((sb) => sb.benefitNumber === selectedBenefit.benefitNumber && !isLoading) && (
                  <Grid container justify="flex-end">
                    <Box sx={{padding: '12px'}}>
                      <Button disabled={lastDayHasPassed} variant="contained" size="large" color="primary" onClick={() => enableBenefit()}>Enable Benefit</Button>
                    </Box>
                  </Grid>
                )}
                {isLoading && <LogoSpinner />}

              </DialogActions>
          </Dialog>
        )}
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    estimates: state.estimator.get('estimates'),
  };
};

export default 
  connect(mapStateToProps, {
    setEstimations,
    setBackButtonPath,
    detectIntent,
    showToast,
    getTempLivingPriceByRegion,
    getPackLoadMovePrice,
  })(BenefitSelections)
;